


















import { computed, defineComponent } from '@vue/composition-api'
import {
  onMounted,
  PropType,
  ref,
  toRefs,
  useContext,
  watch,
} from '@nuxtjs/composition-api'
import InputSelect from '../Inputs/InputSelect.vue'
import { RegionOption } from '@/components/FormInput/BlockNearestOffice.typing'
import { RegionModel } from '@/contracts/api/QueryRegion/QueryRegion.Response'
import { dataRegionsAppeal } from '@/apollo/queries/dataRegionsAppeal';
import { appealsRegionsAdapter } from '@/apollo/adapters/modules/appealsRegionsAdapter';

export default defineComponent({
  components: {
    InputSelect,
  },
  props: {
    value: {
      type: Object as PropType<RegionModel>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    // Регионы из админки
    isRegionsFromAdmin: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { disabled } = toRefs(props)
    const {
      $api,
      app: {
        apolloProvider: {
          defaultClient: { query },
        },
      }
    } = useContext()

    const options = ref<RegionOption[]>([])
    const loading = ref<boolean>(false)
    const errorMsg = ref<false | string>(false)

    const placeholder = computed<string>(() =>
      loading.value ? 'Загрузка...' : 'Ничего не выбрано'
    )

    const fetchRegions = async (): Promise<void> => {
      if (disabled.value) return

      loading.value = true

      try {
        if (props.isRegionsFromAdmin) {
          const {
            data: { regions },
          } = await query({ query: dataRegionsAppeal })

          // Адаптируем регионы из админки к сервисным
          options.value = appealsRegionsAdapter(regions).map((region) => ({
            name: region.name,
            value: {
              SUBJECT_FEDERATION_CODE: region.value
            } as RegionModel
          }));
        } else {
          const regionsResp = await $api.requests.getRegions()
          if (regionsResp.data?.status === 200 && regionsResp.data?.data) {
            const regionList = regionsResp.data.data
            const regionsFiltered = regionList.filter(
              (v) => Number(v.SUBJECT_FEDERATION_CODE) !== 0
            )
            options.value = regionsFiltered.map((region) => ({
              name: region.SUBJECT_FEDERATION_NAME,
              value: region,
            }))
          } else {
            errorMsg.value = 'Ошибка загрузки данных'
          }
        }
      } catch (e) {
        errorMsg.value = 'Ошибка загрузки данных'
      } finally {
        loading.value = false
      }
    }

    const onChange = (event: RegionOption) => {
      emit('input', event)
    }

    onMounted(fetchRegions)
    watch(disabled, fetchRegions)

    const isCompareRegion = (
      option: RegionOption,
      data: RegionModel | null
    ) => {
      if (props.isRegionsFromAdmin) {
        return !!option && !!data && option.value.SUBJECT_FEDERATION_CODE === data.value.SUBJECT_FEDERATION_CODE
      }

      return !!option && !!data && option.value._ID === data.value._ID
    }

    return {
      placeholder,
      options,
      errorMsg,
      loading,
      onChange,
      isCompareRegion,
    }
  },
})
